module.exports = __webpack_public_path__ + "img/309.e633a7f1.png";